type Props = {
  width?: string;
  height?: string;
  fillColor?: string;
};
const CropIcon = (props: Props) => {
  const { width = '16', height = '16', fillColor = '#F2D093' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 1024 1024"
      fill="none"
    >
      <path
        fill={fillColor}
        d="M256 768h672a32 32 0 1 1 0 64H224a32 32 0 0 1-32-32V96a32 32 0 0 1 64 0v672z"
      />
      <path
        fill={fillColor}
        d="M832 224v704a32 32 0 1 1-64 0V256H96a32 32 0 0 1 0-64h704a32 32 0 0 1 32 32z"
      />
    </svg>
  );
};

export default CropIcon;
